import * as React from 'react';

function SvgRomania(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 36 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 20.734h11.846V0H0v20.734z"
        fill="#002B7F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.846 20.734h11.845V0H11.846v20.734z"
        fill="#FCD116"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.691 20.734h11.847V0H23.69v20.734z"
        fill="#CE1126"
      />
    </svg>
  );
}

export default SvgRomania;
